import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'


const FACEBOOK_URL = "https://www.facebook.com/";
const INSTAGRAM_URL = "https://www.instagram.com/";
const LINKEDIN_URL = "https://www.linkedin.com/in/";

function TeamCard({member}) {
    const {name, role, img, ig, fb, ld} = member;
    return (
        <div className="col-lg-3 col-md-6">
            <div className="member">
                <div className="pic"><img src={img} alt="" /></div>
                <h4>{name}</h4>
                <span>{role}</span>
                <div className="social">
                    {ig &&
                        <a href={INSTAGRAM_URL + ig}>
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>}
                    {fb &&
                        <a href={FACEBOOK_URL + fb}>
                            <FontAwesomeIcon icon={faSquareFacebook} />
                        </a>}
                    {ld &&
                        <a href={LINKEDIN_URL + ld}>
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>}
                </div>
            </div>
        </div>
    );
}

export default TeamCard;